import SalePermissionBoundary, { useSalePermissions } from "./components/SalePermissionBoundary";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { legacySaleLocation } from "@/utils/saleNavigation";
import Loading from "@/components/Loading";
import SecondAppLayout from "./layout/SecondAppLayout";
import TelegramLoginGate from "./components/TelegramLoginGate";

const SecondAppHomePage = lazy(() => import("./pages/SecondAppHomePage"));
const SaleListPage = lazy(() => import("./pages/SaleListPage"));
const SaleFormPage = lazy(() => import("./pages/SaleFormPage"));
const SaleDetailPage = lazy(() => import("./pages/SaleDetailPage"));
const LeadListPage = lazy(() => import("./pages/LeadListPage"));
const LeadCreatePage = lazy(() => import("./pages/LeadCreatePage"));
const LeadDetailPage = lazy(() => import("./pages/LeadDetailPage"));
const SettingPage = lazy(() => import("./pages/SettingPage"));

/**
 * Route definitions for Sale Support Mini App (mounted under /sale-support/*)
 */
function SaleEditRoute() {
  const auth = useSalePermissions();
  const location = useLocation();
  return auth.can("sale_management_update") || auth.canSummary(location.pathname) ? <SaleFormPage /> : <SaleDetailPage />;
}

function LegacySaleRedirect() {
  const location = legacySaleLocation(useLocation());
  return <Navigate to={location} state={location.state} replace />;
}

export default function SecondMiniAppRoutes() {
  return (
    <TelegramLoginGate>
    <Suspense fallback={<Loading open />}>
      <Routes>
        <Route path="auth" element={<SecondAppHomePage />} />
        <Route element={<SecondAppLayout />}>
          <Route index element={<SecondAppHomePage />} />
          <Route path="settings" element={<SalePermissionBoundary required={[]} anyOf={["global_configuration_view", "sale_management_view"]}><SettingPage /></SalePermissionBoundary>} />
          <Route path="tasks/*" element={<LegacySaleRedirect />} />
          <Route path="sales" element={<SalePermissionBoundary required={["sale_management_view"]}><SaleListPage key="general" /></SalePermissionBoundary>} />
          <Route path="sales/my" element={<SalePermissionBoundary required={["sale_management_view"]}><SaleListPage key="my" mySales /></SalePermissionBoundary>} />
          <Route path="sales/due" element={<SalePermissionBoundary required={["sale_management_view"]}><SaleListPage key="due" upcoming /></SalePermissionBoundary>} />
          <Route path="sales/follow-up" element={<SalePermissionBoundary required={["sale_management_view"]}><SaleListPage key="follow-up" followUp /></SalePermissionBoundary>} />
          <Route path="sales/new" element={<SalePermissionBoundary required={["sale_management_view", "sale_management_create"]}><SaleFormPage /></SalePermissionBoundary>} />
          <Route path="sales/:id" element={<SalePermissionBoundary required={["sale_management_view"]} allowSummary><SaleEditRoute /></SalePermissionBoundary>} />
          <Route path="sales/:id/edit" element={<SalePermissionBoundary required={["sale_management_view"]} allowSummary><SaleEditRoute /></SalePermissionBoundary>} />
          <Route path="leads" element={<SalePermissionBoundary required={["lead_management_view"]}><LeadListPage key="general" /></SalePermissionBoundary>} />
          <Route path="leads/upcoming" element={<SalePermissionBoundary required={["lead_management_view"]}><LeadListPage key="upcoming" upcoming /></SalePermissionBoundary>} />
          <Route path="leads/new" element={<SalePermissionBoundary required={["lead_management_view", "lead_management_create"]}><LeadCreatePage /></SalePermissionBoundary>} />
          <Route path="leads/:id" element={<SalePermissionBoundary required={["lead_management_view"]}><LeadDetailPage /></SalePermissionBoundary>} />
          <Route path="leads/:id/edit" element={<SalePermissionBoundary required={["lead_management_view"]}><LeadDetailPage /></SalePermissionBoundary>} />
          <Route path="*" element={<SecondAppHomePage />} />
        </Route>
      </Routes>
    </Suspense>
    </TelegramLoginGate>
  );
}
